import axiosInstance from "./axiosInstance";

// Get all coursevideos
export const fetchCourseVideos = async () => {
    const response = await axiosInstance.get("/coursevideo/getall");
    return response.data;
};

export const fetchCourseVideoByCourseId = async (data) => {
    const response = await axiosInstance.get("/coursevideo/getallbycourseid", {
        params: data
      });
    return response.data;
};

export const fetchCourseVideoById = async (data) => {
    const response = await axiosInstance.get("/coursevideo/get", {
        params: data
      });
    return response.data;
};

// Create a new coursevideo
export const createCourseVideo = async (data) => {
    const response = await axiosInstance.post("/coursevideo", data);
    return response.data;
};

// Update a coursevideo
export const updateCourseVideo = async ({ id, data }) => {
    const response = await axiosInstance.put(`/coursevideo/${id}`, data);
    return response.data;
};

// Delete a coursevideo
export const deleteCourseVideo = async (data) => {
    await axiosInstance.delete(`/coursevideo`, {
        params: data
    });
};
